import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MailingSection } from '../../components/views/GroupsSection/MailingSection';
import { updateMailingToggle } from '../../services';
import { TThunkDispatch } from '../../store';
import { selectMailingToggles } from '../../store/mailingToggles';
import { EMailingToggleId } from '../../types/mailingToggles';

export const MailingSectionContainer = () => {
  const toggles = useSelector(selectMailingToggles);
  const dispatch = useDispatch<TThunkDispatch>();

  const handleToggleChange = React.useCallback(
    (id: EMailingToggleId, value: boolean) => {
      dispatch(updateMailingToggle({ id, isActive: value }));
    },
    [dispatch],
  );

  if (!toggles || toggles.length === 0) {
    return null;
  }

  return <MailingSection toggles={toggles} onToggleChange={handleToggleChange} />;
};
